module.exports = __webpack_public_path__ + "img/PINGAN-FPD-detail.ff8e31e9.png";